import PeriodRepository from '../../domain/repositories/PeriodRepository';
import PeriodDataStoreFactory from '../factories/PeriodDataStoreFactory';
import PeriodDataStore from '../datastores/PeriodDataStore';

export default class PeriodDataRepository implements PeriodRepository {
  getCurrentPeriod() {
    const periodDataStore: PeriodDataStore = PeriodDataStoreFactory.create();
    return periodDataStore.getCurrentPeriod();
  }
}
